module.exports = __webpack_public_path__ + "static/media/ic-bookmark-red.c6cb1805.svg";